export const MAX_ATTEMPTS_PER_METHOD = 3;

export type VerificationAttemptCounts = {
  smsAttempts: number;
  prospectAttempts: number;
  kbaAttempts: number;
};

export const isSmsExhausted = (smsAttempts: number): boolean =>
  smsAttempts >= MAX_ATTEMPTS_PER_METHOD;

export const isProspectExhausted = (prospectAttempts: number): boolean =>
  prospectAttempts >= MAX_ATTEMPTS_PER_METHOD;

export const isKbaExhausted = (kbaAttempts: number): boolean =>
  kbaAttempts >= MAX_ATTEMPTS_PER_METHOD;

export const areAllMethodsExhausted = ({
  smsAttempts,
  prospectAttempts,
  kbaAttempts,
}: VerificationAttemptCounts): boolean =>
  isSmsExhausted(smsAttempts) &&
  isProspectExhausted(prospectAttempts) &&
  isKbaExhausted(kbaAttempts);
